module.exports = __webpack_public_path__ + "fonts/ATDa6bAI.woff2";